import { Input, Flex as WebFlex } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { PDFOnly } from '../../../summary/components/PDFOnly.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.js';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { calculations } from '../utils/formatters/calculations.ts';
import { PairedCostSettingsBreakdown } from './PairedCostSettingsBreakdown.tsx';
import { isCosted } from './isCosted.ts';

export const AdjustmentBreakdownManualCost = (props: {
  summary: Tkv2PairedCostSummaryInterfaceV2;
  compSequence: string[];
  id: string;
}) => {
  const commentaryProps = props.summary.exportableCommentaries.manual;
  const [commentary, setCommentary] = useState(commentaryProps.commentary ?? '');
  const title = props.summary.results.adjustmentLabels.manual;

  if (!isCosted(props.summary.results, 'manual')) {
    return null;
  }

  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title={title}
        id="isManualCostInExport"
        commentary={commentaryProps}
      />
      <Typography variant="body1">
        {`The ${title} adjustment is based on the difference between the comparable’s ${title} value
                and the subject’s ${title} value. Value was estimated by the appraiser.`}
      </Typography>
      <PDFOnly>
        <Typography variant="body1">{commentaryProps.commentary ?? ''}</Typography>
      </PDFOnly>
      <SummaryTableHorizontal
        {...props}
        compSequence={props.compSequence}
        summary={props.summary}
        columns={[
          {
            header: 'Feature',
            type: 'feature',
            path: 'text',
            adjustmentType: 'manual',
          },
          {
            header: 'Adjustment Calculation',
            type: 'adjustment',
            path: 'calculations',
            valueFormatter: calculations,
            adjustmentType: 'manual',
          },
          {
            header: 'Adjustment',
            type: 'adjustment',
            path: 'adjustment',
            adjustmentType: 'manual',
            valueFormatter: adjustment,
            textAlign: 'right',
            includeTooltip: true,
          },
        ]}
      />
      <PairedCostSettingsBreakdown {...props.summary} type="manual" />
      <WebOnly>
        <WebFlex marginTop="1rem" width="40rem">
          <Input
            type="multiline"
            onChange={setCommentary}
            value={commentary}
            onClear={() => setCommentary('')}
            onBlur={() => commentaryProps.updateCommentary(commentary)}
            resize="both"
            label="Commentary"
            size="sm"
          />
        </WebFlex>
      </WebOnly>
    </SummarySection>
  );
};
